import React, { FC, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import LoaderOverlay from 'components/PageLayout/LoaderOverlay';
import { getBranding } from 'handlers/settingsSlice';
import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import useUtmSource from 'hooks/useUtmSource';

const CuroWorkflowWrapper: FC = ({ children }) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const dispatchWithUnwrap = useDispatchWithUnwrap();
  const { addUtmQueryToStorage } = useUtmSource();

  const fetchBranding = async () => {
    try {
      setIsLoading(true);
      await dispatchWithUnwrap(getBranding());
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBranding();
    addUtmQueryToStorage();
  }, []);

  return <>{isLoading ? <LoaderOverlay /> : children}</>;
};

const CuroRouterLayout = () => {
  return (
    <CuroWorkflowWrapper>
      <Outlet />
    </CuroWorkflowWrapper>
  );
};

export default CuroRouterLayout;
